module.exports = shared.cookies;